module.exports = __webpack_public_path__ + "static/omnia-f5176a89fc837b766628c79f2c002a19.svg";